// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nselect[data-v-21ef981a] {\n  width: 100px;\n}\n.dropdown-menu[data-v-21ef981a] {\n  max-height: 60vh;\n  overflow-y: scroll;\n}\n.dropdown-item.highlight[data-v-21ef981a] {\n  color: #16181b;\n  text-decoration: none;\n  background-color: #e9ecef;\n}\n", ""]);
// Exports
module.exports = exports;
